import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './features/auth';
import { i18n } from './features/i18n';
import { ThemeProvider } from './features/theme/ThemeProvider';
import { APP_TARGET } from './lib/target';
import { buildRouter } from './router';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// buildRouter() is async because cloud/pi targets dynamic-import the
// cloud route map. Embedded resolves synchronously inside the promise.
// Render a lightweight fallback while the router map loads — typically
// a single tick on cloud, zero work on embedded.
const root = createRoot(rootEl);
root.render(<p className="p-6 text-sm">loading…</p>);

void buildRouter().then((router) => {
  root.render(
    <StrictMode>
      <ThemeProvider defaultTheme={APP_TARGET === 'cloud' ? 'light' : 'dark'}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <I18nextProvider i18n={i18n}>
              <RouterProvider router={router} />
              <Toaster />
            </I18nextProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>,
  );
});
